export default [
  {
    title: 'Definitions',
    parts: [
      {
        listWithTitle: [
          {
            title: 'Service',
            paragraphs: [
              'Service is the www.autoaxess.com website operated by autoaxess'
            ]
          },
          {
            title: 'Personal Data',
            paragraphs: [
              'Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).'
            ]
          },
          {
            title: 'Usage Data',
            paragraphs: [
              'Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).'
            ]
          },
          {
            title: 'Cookies',
            paragraphs: [
              'Cookies are small files stored on your device (computer or mobile device).'
            ]
          },
          {
            title: 'Data Controller',
            paragraphs: [
              'Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal information are, or are to be, processed.',
              'For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.'
            ]
          },
          {
            title: 'Data Processors (or Service Providers)',
            paragraphs: [
              'Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller.',
              'We may use the services of various Service Providers in order to process your data more effectively.'
            ]
          },
          {
            title: 'Data Subject (or User)',
            paragraphs: [
              'Data Subject is any living individual who is using our Service and is the subject of Personal Data.'
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'Information Collection and Use',
    parts: [
      {
        text:
          'We collect several different types of information for various purposes to provide and improve our Service to you.'
      },
      {
        subtitle: 'Types of Data Collected'
      },
      {
        caption: 'Personal Data'
      },
      {
        text:
          'While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:'
      },
      {
        list: [
          'Email address',
          'First name and last name',
          'Phone number',
          'Address, State, Province, ZIP/Postal code, City',
          'Cookies and Usage Data'
        ]
      },
      {
        text:
          'We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or the instructions provided in any email we send.'
      },
      {
        caption: 'Usage Data'
      },
      {
        text:
          'We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.'
      },
      {
        caption: 'Tracking & Cookies Data'
      },
      {
        text:
          'We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.'
      },
      {
        text:
          'Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyse our Service.'
      },
      {
        text:
          'You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.'
      },
      {
        text: 'Examples of Cookies we use:'
      },
      {
        list: [
          'Session Cookies. We use Session Cookies to operate our Service.',
          'Preference Cookies. We use Preference Cookies to remember your preferences and various settings.',
          'Security Cookies. We use Security Cookies for security purposes.'
        ]
      }
    ]
  },
  {
    title: 'Use of Data',
    parts: [
      {
        text: 'autoaxess uses the collected data for various purposes:'
      },
      {
        list: [
          'To provide and maintain our Service',
          'To provide and maintain our Service',
          'To notify you about changes to our Service',
          'To allow you to participate in interactive features of our Service when you choose to do so',
          'To provide customer support',
          'To gather analysis or valuable information so that we can improve our Service',
          'To monitor the usage of our Service',
          'To detect, prevent and address technical issues',
          'To provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information'
        ]
      }
    ]
  },
  {
    title:
      'Legal Basis for Processing Personal Data under the General Data Protection Regulation (GDPR)',
    parts: [
      {
        text:
          'If you are from the European Economic Area (EEA), autoaxess legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Data we collect and the specific context in which we collect it.'
      },
      {
        text: 'autoaxess may process your Personal Data because:'
      },
      {
        list: [
          'We need to perform a contract with you',
          'You have given us permission to do so',
          'The processing is in our legitimate interests and it is not overridden by your rights',
          'For payment processing purposes',
          'To comply with the law'
        ]
      }
    ]
  },
  {
    title: 'Retention of Data',
    parts: [
      {
        text:
          'autoaxess will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and enforce our legal agreements and policies.'
      },
      {
        text:
          'autoaxess will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.'
      }
    ]
  },
  {
    title: 'Transfer of Data',
    parts: [
      {
        text:
          'Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.'
      },
      {
        text:
          'If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.'
      },
      {
        text:
          'Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.'
      },
      {
        text:
          'autoaxess will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.'
      }
    ]
  },
  {
    title: 'Disclosure of Data',
    parts: [
      {
        subtitle: 'Disclosure for Law Enforcement'
      },
      {
        text:
          'Under certain circumstances, autoaxess may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).'
      },
      {
        subtitle: 'Legal Requirements'
      },
      {
        text:
          'autoaxess may disclose your Personal Data in the good faith belief that such action is necessary to:'
      },
      {
        list: [
          'To comply with a legal obligation',
          'To protect and defend the rights or property of autoaxess',
          'To prevent or investigate possible wrongdoing in connection with the Service',
          'To protect the personal safety of users of the Service or the public',
          'To protect against legal liability'
        ]
      }
    ]
  },
  {
    title: 'Security of Data',
    parts: [
      {
        text:
          'The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.'
      }
    ]
  },
  {
    title:
      'Our Policy on "Do Not Track" Signals under the California Online Protection Act (CalOPPA)',
    parts: [
      {
        text:
          'We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.'
      },
      {
        text:
          'You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.'
      }
    ]
  },
  {
    title:
      'Your Data Protection Rights under the General Data Protection Regulation (GDPR)',
    parts: [
      {
        text:
          'If you are a resident of the European Economic Area (EEA), you have certain data protection rights. autoaxess aims to take reasonable steps to allow you to correct, amend, delete or limit the use of your Personal Data.'
      },
      {
        text:
          'If you wish to be informed about what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.'
      },
      {
        text:
          'In certain circumstances, you have the following data protection rights:'
      },
      {
        list: [
          'The right to access, update or delete the information we have on you. Whenever made possible, you can access, update or request deletion of your Personal Data directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.',
          'The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.',
          'The right to object. You have the right to object to our processing of your Personal Data.',
          'The right of restriction. You have the right to request that we restrict the processing of your personal information.',
          'The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.',
          'The right to withdraw consent. You also have the right to withdraw your consent at any time where autoaxess relied on your consent to process your personal information.'
        ]
      },
      {
        text:
          'Please note that we may ask you to verify your identity before responding to such requests.'
      },
      {
        text:
          'You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).'
      }
    ]
  },
  {
    title: 'Service Providers',
    parts: [
      {
        text:
          'We may employ third party companies and individuals to facilitate our Service ("Service Providers"), provide the Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.'
      },
      {
        text:
          'These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.'
      },
      {
        subtitle: 'Payments'
      },
      {
        text:
          'We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).'
      },
      {
        text:
          'We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.'
      },
      {
        text: 'The payment processors we work with are:'
      },
      {
        list: [
          'Authorize.net - Their Privacy Policy can be viewed at https://www.authorize.net/company/privacy/'
        ]
      }
    ]
  },
  {
    title: 'Links to Other Sites',
    parts: [
      {
        text:
          "Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit."
      },
      {
        text:
          'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.'
      }
    ]
  },
  {
    title: "Children's Privacy",
    parts: [
      {
        text:
          'Our Service does not address anyone under the age of 18 ("Children").'
      },
      {
        text:
          'We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.'
      }
    ]
  },
  {
    title: 'Changes to This Privacy Policy',
    parts: [
      {
        text:
          'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.'
      },
      {
        text:
          'We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.'
      },
      {
        text:
          'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.'
      }
    ]
  },
  {
    title: 'Contact Us',
    parts: [
      {
        text:
          'If you have any questions about this Privacy Policy, please contact us:'
      },
      {
        list: ['By phone number: 510 541 8481']
      }
    ]
  }
];
